import { render } from "./add.vue?vue&type=template&id=29146734&ts=true"
import script from "./add.vue?vue&type=script&lang=ts"
export * from "./add.vue?vue&type=script&lang=ts"

import "./add.vue?vue&type=style&index=0&id=29146734&lang=scss"

import exportComponent from "/home/quangphuc/s-tech/admin-nhaongay/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__